(() => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  const parallaxEls = Array.from(document.querySelectorAll('.parallax__layer[data-parallax]'));
  if (parallaxEls.length === 0) return;

  const videoContainer = parallaxEls[0];
  if (!videoContainer) return;

  const disableParallaxMobile = videoContainer.dataset.disableParallaxMobile === 'true';
  if (disableParallaxMobile && window.innerWidth <= 767) return;

  const heroWrapper = videoContainer.closest('.m-holiday-hero__wrapper');
  if (!heroWrapper) return;

  let ticking = false;
  let isInViewport = false;
  let state = {
    containerTop: 0,
    containerHeight: 0,
    videoHeight: 0,
    viewportHeight: 0,
  };

  function computeBounds() {
    const containerRect = heroWrapper.getBoundingClientRect();
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;

    state.containerTop = containerRect.top + scrollY;
    state.containerHeight = containerRect.height;
    state.videoHeight = videoContainer.offsetHeight;
    state.viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isInViewport = entry.isIntersecting;
        if (isInViewport) {
          computeBounds();
          update();
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '0px',
    }
  );

  observer.observe(heroWrapper);

  function update() {
    if (!isInViewport) {
      ticking = false;
      return;
    }

    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const containerBottom = state.containerTop + state.containerHeight;
    const containerStart = state.containerTop;
    const scrollProgress = scrollY - containerStart;

    parallaxEls.forEach((el) => {
      const speed = parseFloat(el.dataset.speed) || 0.5;

      if (scrollY < containerStart) {
        el.style.transform = 'translate3d(0, 0, 0)';
        el.classList.remove('sticky-active');
      } else if (scrollY < containerBottom) {
        const totalScrollRange = state.containerHeight + state.viewportHeight;
        const progress = Math.max(0, scrollProgress);
        const translateY = progress * speed;

        el.style.transform = `translate3d(0, ${translateY}px, 0)`;
        el.classList.add('sticky-active');
      } else {
        const totalScrollRange = state.containerHeight + state.viewportHeight;
        const maxProgress = containerBottom - containerStart;
        const translateY = maxProgress * speed;

        el.style.transform = `translate3d(0, ${translateY}px, 0)`;
        el.classList.add('sticky-active');
      }
    });

    ticking = false;
  }

  function onScroll() {
    if (!isInViewport) return;

    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  function onResize() {
    computeBounds();
    update();
  }

  computeBounds();
  update();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
})();
